import { array, bool, func, number, oneOf, string } from 'prop-types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import InfiniteList from '../../../InfiniteList'
import Loader from '../../../Loader'
import { kuiperClassNames } from '../../../utils'
import Filter from '../../Filter'

import './styles.scss'

const transitionName = (lastPath, currentPath) =>
  kuiperClassNames(currentPath.length > lastPath.length ? 'forward' : 'back')

const getChild = (top, path) =>
  top.find((child) => child.id === path).childOptions

const itemsAtPath = (tree, path) => path.reduce(getChild, tree)

const backButton = (
  tree,
  path,
  onPathChange,
  highlightedFilterId,
  onFilterMouseMove,
  theme
) => {
  const previousPath = path.slice(0, -1)
  const previousItem = itemsAtPath(tree, previousPath).find(
    (item) => item.id === path[path.length - 1]
  )

  if (path.length) {
    const reverser = onPathChange.bind(this, previousPath)
    return (
      <Filter
        deep={path.length > 1}
        highlighted={previousItem.id === highlightedFilterId}
        isReversible={true}
        key={previousItem.id}
        onClick={reverser}
        onMouseMove={onFilterMouseMove}
        onReverse={reverser}
        theme={theme}
        {...previousItem}
      />
    )
  }
  return null
}

const WrappedFilterBrowser = ({
  currentPath,
  filterTree,
  highlightedFilterId,
  lastPath,
  loading,
  onFilterMouseMove,
  onPathChange,
  renderer,
  scrollToIndex,
  theme = 'light',
}) => {
  const items = itemsAtPath(filterTree, currentPath)
  const renderedItems = loading ? (
    <Loader minHeight={26} theme="transparent" />
  ) : (
    items.map(renderer)
  )

  return (
    <div className={kuiperClassNames('filter-browser')}>
      {Boolean(filterTree.length) && (
        <TransitionGroup
          className={kuiperClassNames('filter-browser-transition-group')}
        >
          <CSSTransition
            classNames={transitionName(lastPath, currentPath)}
            timeout={150}
          >
            <InfiniteList
              key={currentPath.length}
              rowHeight={26}
              marginBottom={4}
              scrollToIndex={scrollToIndex}
            >
              {backButton(
                filterTree,
                currentPath,
                onPathChange,
                highlightedFilterId,
                onFilterMouseMove,
                theme
              )}
              {renderedItems}
            </InfiniteList>
          </CSSTransition>
        </TransitionGroup>
      )}
      {Boolean(!filterTree.length) && (
        <span style={{ fontSize: 13, textAlign: 'center' }}>
          No labels have been created in this workspace yet.
          <br />
          To filter in this view, you must first create a label.
        </span>
      )}
    </div>
  )
}
WrappedFilterBrowser.displayName =
  'Kuiper: WrappedFilterBrowser ← FilterBrowser ← SearchResults ← FilterBar '

WrappedFilterBrowser.propTypes = {
  currentPath: array,
  filterTree: array,
  highlightedFilterId: string,
  lastPath: array,
  loading: bool,
  onFilterMouseMove: func,
  onPathChange: func,
  renderer: func,
  scrollToIndex: number,
  theme: oneOf(['dark', 'light']),
}

export default WrappedFilterBrowser
